const apiUrl = process.env.REACT_APP_API_URL;

export const GetAllPages = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/config/pages`);
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.error('Error fetching pages:', error);
        return [];
    }
};
